var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01772 0.502743C8.29562 -0.167581 9.20437 -0.167581 9.48228 0.502743L11.1634 4.55821C11.279 4.8372 11.5305 5.02834 11.8199 5.05719L16.0265 5.4765C16.7219 5.5458 17.0026 6.44989 16.4791 6.93345L13.3115 9.85918C13.0936 10.0605 12.9975 10.3697 13.0607 10.6665L13.9794 14.9812C14.1312 15.6944 13.3961 16.2531 12.7946 15.8816L9.15577 13.6343C8.90547 13.4798 8.59452 13.4798 8.34423 13.6343L4.70542 15.8816C4.10396 16.2531 3.36877 15.6944 3.52062 14.9812L4.4393 10.6665C4.5025 10.3697 4.40644 10.0605 4.18853 9.85918L1.02093 6.93345C0.497363 6.44989 0.778176 5.5458 1.47348 5.4765L5.68008 5.05719C5.96947 5.02834 6.22097 4.8372 6.33662 4.55821L8.01772 0.502743Z",
    fill: "#F4BF00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.29271e34af4572dca0d980b33603d4e0.svg";
export { ForwardRef as ReactComponent };